import { Idea, w2d2dApiClient } from "../w2d2d-api-client";
import { ResourceWrapper } from "../../eventer-pod/client/ResourceWrapper";
import { SerializedObject, SerializedResource } from "../../eventer-pod/shared/eventer-pod";
import Semantic from "../../eventer/Semantic";

export function ideaToEvent(idea: Idea): ResourceWrapper {
    const subject = `${w2d2dApiClient.baseUrl}ideas/${idea.id}`;
    const graph = w2d2dApiClient.appBaseUrl;

    const predicates: Record<string, SerializedObject[]> = {};

    // Add name (title)
    predicates["https://schema.org/name"] = [{
        object: idea.title,
        graph,
    }];

    // Add description if present
    if (idea.description) {
        predicates["https://schema.org/description"] = [{
            object: idea.description,
            graph,
        }];
    }

    // Add start date if present
    if (idea.startsAt) {
        predicates["https://schema.org/startDate"] = [{
            object: idea.startsAt,
            graph,
            datatype: Semantic.w3.types.dateTime.uri,
        }];
    }

    // Add end date if present
    if (idea.endsAt) {
        predicates["https://schema.org/endDate"] = [{
            object: idea.endsAt,
            graph,
            datatype: Semantic.w3.types.dateTime.uri,
        }];
    }

    // Add event status (scheduled)
    predicates[Semantic.SchemaOrg.Predicates.eventStatus.uri] = [{
        object: Semantic.SchemaOrg.Predicates.eventStatus.eventScheduled,
        graph,
    }];

    // Add reference to original event URI if present
    if (idea.eventUri) {
        predicates["https://schema.org/subjectOf"] = [{
            object: idea.eventUri,
            graph,
        }];
    }

    const serializedResource: SerializedResource = {
        subject,
        predicates,
    };

    return new ResourceWrapper(serializedResource);
}
